<template>
	<v-tooltip top>
		<v-btn
			dark
			flat
			icon
			slot="activator"
			small
			:color="color"
			:disabled="disabled"
			@click.prevent="clickIcon"
		>
			<template v-if="icon">
				<v-icon :color="color" :size="size" :style="isListAll">{{ icon }}</v-icon>
			</template>
			<template v-else>
				<img :src="img" alt="text" :height="size">
			</template>
		</v-btn>
		<span>{{ text }}</span>
	</v-tooltip>
</template>

<script>

function clickIcon($e) {
	this.$emit('click-icon', $e);
}

function isListAll() {
	return this.icon === 'list_all' ? 'height:24px;width:24px' : '';
}

export default {
	name: 'app-tooltip-button',
	computed: {
		isListAll,
	},
	props: {
		color: {
			type: String,
			default: 'success',
		},
		icon: String,
		img: String,
		size: [Number, String],
		text: {
			type: String,
			required: true,
		},
		disabled: {
			type: Boolean,
			default: false,
		},
	},
	methods: {
		clickIcon,
	},
};
</script>



// WEBPACK FOOTER //
// src/components/shared/app-tooltip-button.vue